'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Button, Input, Icon } from 'dumb';
import { TableList, TableListCell, TableListRow } from 'dumb/tables/table-list';
import { ModalRow } from 'dumb/modal';

// phrases
import phrases from '../../../waitingTimePerformanceGridEntries.phrases';

class WaitingTimePerformanceGridEntriesBatchStepList extends Component {
	_onRemoveEntry(identifier) {
		const { removeBatchListItem } = this.props;

		removeBatchListItem(identifier);
	}

	_editListEntry(e, row, type) {
		const value = e?.target?.value ?? e;

		// edits the row in the store
		this.props.editBatchListItem({
			identifier: row.identifier,
			[type]: value,
		});
	}

	render() {
		const { batchList, addBatchListItemRow } = this.props;

		return (
			<>
				<TableList>
					<thead>
						<tr>
							<th>{phrases.MODAL_BATCH_STEP_LIST_TABLE_NUMBER}</th>
							<th>{phrases.MODAL_BATCH_STEP_NAME}</th>
							<th>{phrases.MODAL_BATCH_STEP_DESCRIPTION}</th>
							<th>{phrases.MODAL_BATCH_STEP_BADGE}</th>
							<th>{phrases.MODAL_BATCH_STEP_VALUE}</th>
							<th>{phrases.MODAL_BATCH_STEP_PERCENTAGE}</th>
							<th>{phrases.MODAL_BATCH_STEP_MINIMUM_ORDERS}</th>

							<th />
						</tr>
					</thead>
					<tbody>
						{batchList.map((entry, i) => {
							const deleteButtonDisabled = batchList.length === 1;

							return (
								<TableListRow key={entry.identifier}>
									<TableListCell>{i + 1}</TableListCell>

									<TableListCell>
										<Input
											id={`name-${entry.identifier}`}
											placeholder="Enter name..."
											value={entry.name}
											required
											onChange={(event) =>
												this._editListEntry(event, entry, 'name')
											}
										/>
									</TableListCell>

									<TableListCell>
										<Input
											id={`description-${entry.identifier}`}
											placeholder="Enter description..."
											value={entry.description}
											onChange={(event) =>
												this._editListEntry(event, entry, 'description')
											}
										/>
									</TableListCell>

									<TableListCell>
										<Input
											id={`badge-${entry.identifier}`}
											placeholder="Enter badge..."
											value={entry.badge}
											required
											onChange={(event) =>
												this._editListEntry(event, entry, 'badge')
											}
										/>
									</TableListCell>

									<TableListCell>
										<Input
											id={`value-${entry.identifier}`}
											placeholder="Enter value..."
											value={entry.value}
											type="number"
											required
											onChange={(event) =>
												this._editListEntry(event, entry, 'value')
											}
										/>
									</TableListCell>

									<TableListCell>
										<Input
											id={`percentage-${entry.identifier}`}
											placeholder="Enter percentage..."
											value={entry.percentage}
											type="number"
											required
											onChange={(event) =>
												this._editListEntry(event, entry, 'percentage')
											}
										/>
									</TableListCell>

									<TableListCell>
										<Input
											id={`minimumOrders-${entry.identifier}`}
											placeholder="Enter minimum orders..."
											value={entry.minimumOrders}
											type="number"
											required
											onChange={(event) =>
												this._editListEntry(event, entry, 'minimumOrders')
											}
										/>
									</TableListCell>

									<TableListCell>
										<Button
											type="negative"
											size="tiny"
											disabled={deleteButtonDisabled}
											onClick={() => this._onRemoveEntry(entry.identifier)}>
											<Icon name="delete" />
										</Button>
									</TableListCell>
								</TableListRow>
							);
						})}
					</tbody>
				</TableList>

				<ModalRow
					typeAddNewRow
					tooltipZIndex={600}
					tooltipText={phrases.MODAL_BATCH_STEP_LIST_TOOLTIP}
					onClick={addBatchListItemRow}
				/>
			</>
		);
	}
}

WaitingTimePerformanceGridEntriesBatchStepList.propTypes = {
	batchList: PropTypes.array,
	editBatchListItem: PropTypes.func,
	removeBatchListItem: PropTypes.func,
	addBatchListItemRow: PropTypes.func,
};

export default WaitingTimePerformanceGridEntriesBatchStepList;
